import { render, staticRenderFns } from "./UpdateBalance.vue?vue&type=template&id=6db5f360&scoped=true"
import script from "./UpdateBalance.vue?vue&type=script&lang=ts"
export * from "./UpdateBalance.vue?vue&type=script&lang=ts"
import style0 from "./UpdateBalance.vue?vue&type=style&index=0&id=6db5f360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db5f360",
  null
  
)

export default component.exports